import { put, call, takeLatest } from "redux-saga/effects";
import axios from 'axios';

import API_ENDPOINTS from "@services/apiConfig";

/********** ACTION_TYPES **********/
export const actionTypes = {
  submitAssessment: "assessment/INITIATE_SUBMIT_ASSESSMENT",
  submitAssessmentFailed: "assessment/SUBMIT_ASSESSMENT_FAILED",
  submitAssessmenttFulfilled: "assessment/SUBMIT_ASSESSMENT_FULFILLED",
};

/********** REDUCER **********/
const initialState = {
  fetching: false,
  fetched: false,
  data: null,
  errMsg: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.submitAssessment: {
      return { ...state, fetching: true };
    }
    case actionTypes.submitAssessmentFailed: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        errMsg: action.payload,
      };
    }
    case actionTypes.submitAssessmentFulfilled: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload,
        errMsg: null,
      };
    }
    default: {
      return state;
    }
  }
};

/********** ACTION_CREATORS **********/
export const actions = {
  submitAssessment: (data) => ({
    type: actionTypes.submitAssessment,
    payload: data,
  }),
  submitAssessmentFailed: (data) => ({
    type: actionTypes.submitAssessmentFailed,
    payload: data,
  }),
  submitAssessmentFulfilled: (data) => ({
    type: actionTypes.submitAssessmentFulfilled,
    payload: data,
  }),
};

/********** WORKERS **********/
function* submitAssessmentWorker(action) {
  const { payload } = action;
  try {
    const response = yield call(
        [axios, 'post'],
        API_ENDPOINTS.ASSESSMENT,
        { 
          type : payload,
        }
      )
    if (response.status == 200) {
      window.location.assign(`/app/manage_account`);
    }
  } catch (err) {
    let errMsg = (err && err.response.data.error) || "Something went wrong";
    yield put(actions.submitAssessmentFailed(errMsg));
  }
}


/********** SAGAS **********/
export function* saga() {
  yield takeLatest(actionTypes.submitAssessment, submitAssessmentWorker);
}